import { Outlet } from 'react-router';
import { useTrads } from '../contexts/trads/useTrads';
function DonsLayout() {
  const {translate}=useTrads();

  return (
    <>
    <div className="col-12  master dons-layout">
      <header></header>

      <div id="don-content">
        <Outlet />
      </div>
      
    </div>
    <footer>{translate('global_footer')}</footer>
    </>
  );
}

export default DonsLayout;